var _classCallCheck = require("/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("XPReport", [], t) : "object" == typeof exports ? exports.XPReport = t() : e.XPReport = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var t = {};
    function n(o) {
      if (t[o]) return t[o].exports;
      var i = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(o, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(1);
    t.default = o.default;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(2),
      i = n(4),
      c = n(3);
    t.default = /*#__PURE__*/function () {
      function _class(e, t, n) {
        _classCallCheck(this, _class);
        this.data = Object.assign({}, e), this.opts = Object.assign({}, i.DEFAULT_OPTION, t), this.uidFunc = n || c.noop;
      }
      _createClass(_class, [{
        key: "sendData",
        value: function sendData(e, t, n) {
          var r = Object.assign({}, this.opts, t),
            a = Object.assign({
              appid: "",
              so: "",
              uid: Object(c.getCookie)("wasxuid_r"),
              ls: Object(c.getOrCreateLocalId)(),
              re: window.document.referrer,
              url: window.location.href,
              type: "page",
              mcode: "",
              ch: ""
            }, this.data, e);
          if ((n = n || this.uidFunc) && "function" == typeof n) {
            var _e = n();
            _e && _e.then ? _e.then(function (e) {
              a.uid = e, Object(o.default)(i.URL[r.env], a);
            }, function () {
              console && console.warn && console.warn("提供的uid获取函数，获取uid错误！");
            }) : (void 0 !== _e && (a.uid = _e), Object(o.default)(i.URL[r.env], a));
          } else Object(o.default)(i.URL[r.env], a);
        }
      }, {
        key: "getCommonDeviceId",
        value: function getCommonDeviceId() {
          var e = this.opts.env;
          return new Promise(function (t, n) {
            var o = document.createElement("iframe");
            o.style.display = "none", o.width = 0, o.height = 0, o.setAttribute("src", i.IFRAME_URL[e]), document.body.appendChild(o), o.addEventListener("load", function () {
              try {
                if (o.contentWindow) {
                  var _e2 = o.contentWindow.window.getDeviceId;
                  _e2 ? t(_e2()) : n();
                } else n();
              } catch (e) {
                n();
              }
            });
          });
        }
      }, {
        key: "send",
        value: function send(e, t, n) {
          var o = this,
            i = this.opts.closeIframe;
          if (i) return Object.assign(e, {
            nls: Object(c.getOrCreateLocalId)()
          }), void o.sendData(e, t, n);
          -1 !== window.location.host.indexOf("localhost") ? document.domain = "localhost" : -1 !== window.location.host.indexOf("xiaopeng.local") ? document.domain = "xiaopeng.local" : -1 !== window.location.host.indexOf("xiaopeng.com") ? document.domain = "xiaopeng.com" : -1 !== window.location.host.indexOf("ypeng.com") && (document.domain = "ypeng.com");
          var r = window.localStorage;
          r.getItem("newDeviceId") ? (Object.assign(e, {
            nls: r.getItem("newDeviceId")
          }), o.sendData(e, t, n)) : this.getCommonDeviceId().then(function (i) {
            r.setItem("newDeviceId", i), Object.assign(e, {
              nls: i
            }), o.sendData(e, t, n);
          }).catch(function (i) {
            console.log(i), o.sendData(e, t, n);
          });
        }
      }], [{
        key: "getCookie",
        value: function getCookie(e) {
          return Object(c.getCookie)(e);
        }
      }, {
        key: "getOrCreateLocalId",
        value: function getOrCreateLocalId() {
          return Object(c.getOrCreateLocalId)();
        }
      }]);
      return _class;
    }();
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return i;
    });
    var o = n(3);
    function i(e, t) {
      if (void 0 === window || void 0 === window.document) return void (console && console.warn && console.warn("非浏览器环境，数据上报功能无法使用！"));
      if (void 0 === t) return void (console && console.warn && console.warn("无数据需要上报！"));
      var n = window.document.createElement("img"),
        i = window.document.body;
      n.style.display = "none", n.src = "".concat(e, "?").concat(Object(o.params)(t)), i.appendChild(n), window.setTimeout(function () {
        i.removeChild(n);
      }, 50);
    }
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return Object.keys(e).map(function (t) {
        return "".concat(t, "=").concat(encodeURIComponent(e[t]));
      }).join("&");
    }
    function i() {}
    function c(e) {
      var t = ("; " + window.document.cookie).split("; " + e + "=");
      return 2 == t.length ? t.pop().split(";").shift() : "";
    }
    function r() {
      if (window && window.localStorage) {
        var _e3 = window.localStorage;
        var _t = _e3.getItem("deviceId");
        return _t || (_t = "".concat((1e6 * Math.random()).toString(16), "_").concat(new Date().getTime()), _e3.setItem("deviceId", _t), _t);
      }
      return "no_support_localStorage";
    }
    n.r(t), n.d(t, "params", function () {
      return o;
    }), n.d(t, "noop", function () {
      return i;
    }), n.d(t, "getCookie", function () {
      return c;
    }), n.d(t, "getOrCreateLocalId", function () {
      return r;
    });
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "URL", function () {
      return o;
    }), n.d(t, "DEFAULT_OPTION", function () {
      return i;
    }), n.d(t, "IFRAME_URL", function () {
      return c;
    });
    var o = {
        test: "http://logan-gateway.dev.logan.xiaopeng.local/xp-cs-api-boot/open/get/image",
        pre: "https://csapi.cs-pre.xiaopeng.com/open/get/image",
        production: "https://ext-svc.xiaopeng.com/api/log/open/get/image"
      },
      i = {
        env: "production"
      },
      c = {
        test: "http://static.test.xiaopeng.local/apps/xp-static-common/index.html",
        pre: "https://static.deploy-test.xiaopeng.com/apps/xp-static-common/index.html",
        production: "https://static.xiaopeng.com/apps/xp-static-common/index.html"
      };
  }]).default;
});